import Button from '@/features/ui/buttons/components/Button'
import PlusIcon from '@/features/ui/icons/components/PlusIcon'
import React, { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

interface InsertNoteButtonProps {
    onPress: () => void
}

const InsertNoteButton: FC<InsertNoteButtonProps> = ({ onPress }) => {
    const { t } = useTranslation()

    return (
        <Button
            type="naked"
            onPress={onPress}
            FrontIcon={PlusIcon}
            textStyle={{ textTransform: 'uppercase' }}
            style={{ alignSelf: 'flex-start', paddingHorizontal: 8 }}
        >
            {t('common.insertNoteFormContent.insertNote')}
        </Button>
    )
}

export default memo(InsertNoteButton)
